import PropTypes from 'prop-types';

export default PropTypes.shape({
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired
});
